import React from "react";
import PropTypes from "prop-types";
import "./ColoredCheckbox.scss";

const ColoredCheckbox = ({
  label,
  color,
  checked,
  disabled = false,
  name,
  onChange,
  value = "",
}) => {
  return (
    <div className={`colored-checkbox ${color}`}>
      <label>
        <input
          type="checkbox"
          name={name}
          checked={checked}
          disabled={disabled}
          onChange={onChange}
          value={value}
        />
        {label && <span className="checkbox-label">{label}</span>}
      </label>
    </div>
  );
};

ColoredCheckbox.propTypes = {
  label: PropTypes.string, // No longer required
  color: PropTypes.string.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ColoredCheckbox;
